export default __webpack_public_path__ + "static/flowns-72f393463c3285dbd631004189cf363d.png";